// utils/dateValidationRules.js
export const dateFieldLimits = {
  birthDate: {
    min: new Date(1900, 0, 1),
    max: new Date(),
  },
  firstWorkingDay: {
    min: new Date(1900, 0, 1),
    max: new Date(2500, 0, 1),
  },
};
